<template><section><template>
<h3>数字输入框</h3>
<div class="bs-docs-section">
<div class="bs-example">
  <n3-input-number v-model="value"></n3-input-number>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-input-number</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-input-number</span>&gt;</span>
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td><code v-pre="">String</code></td>
<td>－</td>
<td></td>
</tr>
<tr>
<td>readonly</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>只读</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>禁止改变值</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">220px</code></td>
<td>宽度</td>
</tr>
<tr>
<td>placeholder</td>
<td><code v-pre="">String</code></td>
<td>－</td>
<td>placeholder</td>
</tr>
<tr>
<td>max</td>
<td><code v-pre="">Number</code></td>
<td>-</td>
<td>最大值</td>
</tr>
<tr>
<td>min</td>
<td><code v-pre="">Number</code></td>
<td>-</td>
<td>最小值</td>
</tr>
<tr>
<td>step</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">1</code></td>
<td>增减量值</td>
</tr>
</tbody>
</table>
<h3>事件</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>blur</td>
<td>失焦</td>
<td>-</td>
</tr>
<tr>
<td>focus</td>
<td>聚焦</td>
<td>-</td>
</tr>
<tr>
<td>change</td>
<td>值变化</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>其他表单相关参数，请移步 <a href="#n3FormDocs">表单验证</a> 待验证组件参数</p>
</div>
</template>

</section></template>

<script>

export default {
  data () {
    return {
      value: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3InputNumberDocs.md?137344d1